// extracted by mini-css-extract-plugin
module.exports = {"itemSectionInfoJtails":"SectionInfo-Jtails_itemSectionInfoJtails_1tloi","isStyleDingBeauty":"SectionInfo-Jtails_isStyleDingBeauty_yCb9d"};